module.exports = __webpack_public_path__ + "static/media/skull.bafe2c40.svg";